import reducer from "./reducers";

import * as escuelasOps from "./operations";
import * as escuelasTypes from "./types";
import * as escuelasSelectores from "./selectors";

export { escuelasOps, escuelasTypes, escuelasSelectores };
export default reducer;



// WEBPACK FOOTER //
// ./src/ducks/escuelas/index.js